var map = {
	"./btn_socialmedia-01IOS_CH.png": 1181,
	"./btn_socialmedia-01IOS_EN.png": 1182,
	"./btn_socialmedia-02Andriod_CH.png": 1183,
	"./btn_socialmedia-02Andriod_EN.png": 1184,
	"./img_socialmedia-01FB.png": 1185,
	"./img_socialmedia-02Snapchat.png": 1186,
	"./img_socialmedia-03Msger.png": 1187,
	"./img_socialmedia-04Whatsapp.png": 1188,
	"./img_socialmedia-05TT.png": 1189,
	"./img_socialmedia-06wechat.png": 1190
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 215;